/// <amd-module name="TFS/Admin/Groups/Pivots/Permissions/Constants" />
import { IPermissionsGroupKey } from "TFS/Admin/Groups/Common/Contracts";
import * as Resources from "TFS/Admin/Groups/Common/Resources";
import { IMenuGroup } from "VSSUI/Menu";

export const OrgPermissionsGroupKey: IPermissionsGroupKey = {
    "2dab47f9-bd70-49ed-9bd5-8eb051e59c028": Resources.Boards, // key = NamespaceId + permissionBit
    "66312704-deb5-43f9-b51c-ab4ff5e351c38": Resources.Repos,
    "66312704-deb5-43f9-b51c-ab4ff5e351c34": Resources.Repos,
    "3e65f728-f8bc-4ecd-8764-7e378b19bfa764": Resources.General,
    "66312704-deb5-43f9-b51c-ab4ff5e351c32": Resources.Repos,
    "3e65f728-f8bc-4ecd-8764-7e378b19bfa74": Resources.General,
    "2dab47f9-bd70-49ed-9bd5-8eb051e59c024": Resources.Boards,
    "3e65f728-f8bc-4ecd-8764-7e378b19bfa71024": Resources.Boards,
    "2dab47f9-bd70-49ed-9bd5-8eb051e59c022": Resources.Boards,
    "52d39943-cb85-4d7f-8fa8-c6baac8738194": Resources.General,
    "1f4179b3-6bac-4d01-b421-71ea091714002": Resources.General,
    "2dab47f9-bd70-49ed-9bd5-8eb051e59c021": Resources.Boards,
    "1f4179b3-6bac-4d01-b421-71ea091714004": Resources.ServiceAccount,
    "302acaca-b667-436d-a946-87133492041c2": Resources.Pipelines,
    "3e65f728-f8bc-4ecd-8764-7e378b19bfa7512": Resources.TestPlans,
    "1f4179b3-6bac-4d01-b421-71ea0917140016": Resources.ServiceAccount,
    "302acaca-b667-436d-a946-87133492041c4": Resources.Pipelines,
    "302acaca-b667-436d-a946-87133492041c1": Resources.Pipelines,
    "1f4179b3-6bac-4d01-b421-71ea091714001": Resources.General,
    "3e65f728-f8bc-4ecd-8764-7e378b19bfa7128": Resources.ServiceAccount,
    "302acaca-b667-436d-a946-87133492041c8": Resources.Pipelines,
    "a6cc6381-a1ca-4b36-b3c1-4e65211e82b61": Resources.Auditing,
    "a6cc6381-a1ca-4b36-b3c1-4e65211e82b64": Resources.Auditing,
    "a6cc6381-a1ca-4b36-b3c1-4e65211e82b68": Resources.Auditing,
    "302acaca-b667-436d-a946-87133492041c16": Resources.Pipelines,
    "3e65f728-f8bc-4ecd-8764-7e378b19bfa72048": Resources.Policies,
    "3e65f728-f8bc-4ecd-8764-7e378b19bfa732": Resources.Boards
};

export const ProjectPermissionsGroupKey: IPermissionsGroupKey = {
    // Project level permissions
    "52d39943-cb85-4d7f-8fa8-c6baac8738194": Resources.General, // key = NamespaceId + permissionBit
    "52d39943-cb85-4d7f-8fa8-c6baac8738191048576": Resources.Boards,
    "52d39943-cb85-4d7f-8fa8-c6baac8738198388608": Resources.Boards,
    "bb50f182-8e5e-40b8-bc21-e8752a1e7ae22": Resources.Boards,
    "52d39943-cb85-4d7f-8fa8-c6baac8738198": Resources.TestPlans,
    "52d39943-cb85-4d7f-8fa8-c6baac8738198192": Resources.Boards,
    "d34d3680-dfe5-4cc6-a949-7d9c68f73cba4": Resources.Analytics,
    "52d39943-cb85-4d7f-8fa8-c6baac873819256": Resources.TestPlans,
    "52d39943-cb85-4d7f-8fa8-c6baac8738192": Resources.General,
    "d34d3680-dfe5-4cc6-a949-7d9c68f73cba2": Resources.Analytics,
    "52d39943-cb85-4d7f-8fa8-c6baac873819131072": Resources.General,
    "52d39943-cb85-4d7f-8fa8-c6baac8738194096": Resources.TestPlans,
    "52d39943-cb85-4d7f-8fa8-c6baac8738192048": Resources.TestPlans,
    "52d39943-cb85-4d7f-8fa8-c6baac87381916384": Resources.Boards,
    "52d39943-cb85-4d7f-8fa8-c6baac87381932768": Resources.Boards,
    "52d39943-cb85-4d7f-8fa8-c6baac87381965536": Resources.General,
    "52d39943-cb85-4d7f-8fa8-c6baac8738192097152": Resources.General,
    "52d39943-cb85-4d7f-8fa8-c6baac8738194194304": Resources.General,
    "58450c49-b02d-465a-ab12-59ae512d65311": Resources.Analytics,
    "52d39943-cb85-4d7f-8fa8-c6baac8738191": Resources.General,
    "52d39943-cb85-4d7f-8fa8-c6baac873819512": Resources.TestPlans
};

export const OrgMenuGroups: IMenuGroup[] = [
    { key: Resources.General, rank: 1 },
    { key: Resources.ServiceAccount, rank: 2 },
    { key: Resources.Boards, rank: 3 },
    { key: Resources.Repos, rank: 4 },
    { key: Resources.Pipelines, rank: 5 },
    { key: Resources.TestPlans, rank: 6 },
    { key: Resources.Auditing, rank: 7 },
    { key: Resources.Policies, rank: 8 },
    { key: Resources.Other, rank: 9 }
];

export const ProjectMenuGroups: IMenuGroup[] = [
    { key: Resources.General, rank: 1 },
    { key: Resources.Boards, rank: 2 },
    { key: Resources.Analytics, rank: 3 },
    { key: Resources.TestPlans, rank: 4 },
    { key: Resources.Other, rank: 5 }
];
